import { Link } from "react-router-dom";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import DSBox from "../../../system-design/DSBox";
import DSChip from "../../../system-design/DSChip";
import DSCircularProgress from "../../../system-design/DSCircularProgress";
import DSIconButton from "../../../system-design/DSIconButton";
import DSTypography from "../../../system-design/DSTypography";
import useOrderByNameQuery from "../../hooks/useOrderByNameQuery";

const formatOrderDate = (date: Date | string) =>
  new Date(date).toLocaleString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

type OrderInfoRowProps = {
  orderName: string;
  onDetach: (orderName: string) => void;
};

const OrderInfoRow = ({ orderName, onDetach }: OrderInfoRowProps) => {
  const { data: order, isLoading } = useOrderByNameQuery(orderName);

  return (
    <DSBox sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {orderName.substring(0, 2) === "P2" ? (
        <Link
          to={`https://admin.shopify.com/store/klydo-clock/orders?query=${orderName}`}
          target="_blank"
        >
          {orderName}
        </Link>
      ) : (
        <DSTypography variant="body2">{orderName}</DSTypography>
      )}

      <DSIconButton
        size="small"
        title="Detach order"
        onClick={() => onDetach(orderName)}
        sx={{ ml: 0.5, p: 0 }}
      >
        <LinkOffIcon sx={{ fontSize: 16 }} />
      </DSIconButton>

      {isLoading && <DSCircularProgress size={12} />}

      {order && (
        <DSTypography variant="body2" sx={{ color: "text.secondary" }}>
          ({formatOrderDate(order.orderCreationDate)})
        </DSTypography>
      )}

      {order?.cancelled && (
        <DSChip label="Cancelled" color="error" size="small" />
      )}
    </DSBox>
  );
};

export default OrderInfoRow;
